import {createSlice} from "@reduxjs/toolkit";

const initialCustomerPaymentsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  CustomerPaymentForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const CustomerPaymentsSlice = createSlice({
  name: "CustomerPayments",
  initialState: initialCustomerPaymentsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCustomerPaymentById
    CustomerPaymentFetched: (state, action) => {
      state.actionsLoading = false;
      state.CustomerPaymentForEdit = action.payload.CustomerPaymentForEdit;
      state.error = null;
    },
    // findCustomerPayments
    CustomerPaymentsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createCustomerPayment
    CustomerPaymentCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.CustomerPayment);
    },
    // updateCustomerPayment
    CustomerPaymentUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.CustomerPayment.id) {
          return action.payload.CustomerPayment;
        }
        return entity;
      });
    },
    // deleteCustomerPayment
    CustomerPaymentDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.sales_CustomerPayment_id !== action.payload.sales_CustomerPayment_id);
    },
    // deleteCustomerPayments
    CustomerPaymentsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // CustomerPaymentsUpdateState
    CustomerPaymentsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
